<ion-modal [style]="style" class="app-modal {{size}} {{class || ''}}" [backdropDismiss]="backdropDismiss" #modal [isOpen]="open" (didDismiss)="onCancel()">
  <ng-template>
    <ng-container *ngIf="open">
      <ng-content></ng-content>
    </ng-container>
  </ng-template>
</ion-modal>